import Impactools from "../../assets/img/logosImpactools/logoImpactools.svg"
import ImpactoolsMedicao from "../../assets/img/logosImpactools/logoImpactoolsMedicao.svg"
import ImpactoolsMedicaoSM from "../../assets/img/logosImpactools/logoImpactoolsMedicaoSM.png"
import ImpactoolsConexão from "../../assets/img/logosImpactools/logoImpactoolsConexao.svg"
import ImpactoolsOperacao from "../../assets/img/logosImpactools/logoImpactoolsOperacao.svg"
import ManejeLogoEmbrapaXL from "../../assets/img/logosManeje/manejebem-embrapa-logo.svg"
import ManejeLogoEmbrapaSM from "../../assets/img/logosManeje/manejebem-embrapa-logo-reduzida.svg"
import { useMediaQuery } from "react-responsive"
import { useLocation } from "react-router"
import { getPlatform } from "./platform"

export const platformDetails = (collapsed = false) => {
  const mobile = useMediaQuery({ query: "(max-width: 767px)" })
  const location = useLocation()

  const currentPlatform = getPlatform() == 2 ? "embrapa" : "maneje"

  const ImpactoolsMedicaoLogo = collapsed ? ImpactoolsMedicaoSM : ImpactoolsMedicao
  const ImpactoolsConexaoLogo = collapsed ? ImpactoolsConexão : ImpactoolsConexão
  const ManejeLogoEmbrapa = collapsed ? ManejeLogoEmbrapaSM : ManejeLogoEmbrapaXL

  const { state } = location
  const url = window.location.href

  let platformName
  let platformLogo
  let platformSufix = ""

  if (currentPlatform === "embrapa") {
    platformSufix = "Embrapa"
    platformLogo = mobile ? ManejeLogoEmbrapaXL : ManejeLogoEmbrapa
  } else if (url.includes("conexao")) {
    platformSufix = "Impactools Conexão"
    platformLogo = ImpactoolsOperacao //mobile ? ImpactoolsConexão : ImpactoolsConexaoLogo
  } else if (url.includes("medicao")) {
    platformSufix = "Impactools Medição"
    platformLogo = mobile ? ImpactoolsMedicao : ImpactoolsMedicaoLogo
  } else if (url.includes("operacao")) {
    platformSufix = "Impactools Operação"
    platformLogo = ImpactoolsOperacao
  } else {
    platformLogo = Impactools
    platformSufix = "Impactools"
  }

  platformName = `${state?.name ? `${state?.name} | ` : ""} ${platformSufix}`

  return { currentPlatform, platformName, platformLogo }
}
